import { useGet } from '../../query/useGet'
import { ISharedDiagnostic } from '../../../types/diagnostics'
import { IInvoiceFr } from '../../../types/invoice-fr'

export function useGetInvoiceFr(diagnosticId: ISharedDiagnostic['id']) {
  const path = `/invoices-fr/${diagnosticId}/mine`

  const invoice = useGet<IInvoiceFr>(path)

  const result = invoice.data

  return { result, ...invoice }
}
